import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const FreeRentBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null,
    amtType: _.get(props, "defaults.freeRentAmtType"),
    revenue: _.get(props.rowData[props.field], 'amtType') !== '% of Market' ? props.defaults['freeRentRevenue'] : null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    if (!nextData['amtType']) nextData['amtType'] = props.defaults['freeRentAmtType']
    if (!nextData['revenue']) nextData['revenue'] = props.defaults['freeRentRevenue']

    if (nextData['amtType'] === '% of Market') nextData['revenue'] = null

    delete nextData.items
    delete nextData.freeRentNamedItemId

    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'freerentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput
            field="amt"
            className="automated"
            data={data}
            attrs={attrs}
            min={0}
            max={1200}
            readPrecision={2}
            writePrecision={2}
            trailingZeros={false}
            persist={updateData}
          />
        </div>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['freeRentAmtType']}
            options={['Mos', 'Mos/Yr', '% of Market']}
            persist={updateData}
          />
        </div>
        <div>
          <label>Revenue</label>
          <DropdownInput
            field="revenue"
            className="automated"
            data={data}
            attrs={attrs}
            default={_.get(data, 'amtType') !== '% of Market' ? props.defaults['freeRentRevenue'] : null}
            disabled={_.get(data, 'amtType') === '% of Market'}
            disabledText="N/A"
            options={['Rent', 'Rent + Recovery', 'All Revenues', 'Recovery']}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default FreeRentBasic
